const concentrations = `African and African American Studies
Anthropology
Applied Math
Astrophysics
Art, Film, and Visual Studies
Biomedical Engineering
Celtic Languages and Literatures
Chemical and Physical Biology
Chemistry
Chemistry and Physics
Classics
Comparative Literature
Comparative Study of Religion
Computer Science
Earth and Planetary Sciences
East Asian Studies
Economics
Educational Studies
Electrical Engineering
Energy and the Environment
English
Environmental Science and Engineering
Environmental Science and Public Policy
Ethnicity, Migration, Rights
European History, Politics, and Societies
Folklore and Mythology
Germanic Languages and Literatures
Global Health and Health Policy
Government
History
History and Literature
History and Science
History of Art and Architecture
Human Developmental and Regenerative Biology
Human Evolutionary Biology
Integrative Biology
Linguistics
Mathematics
Mechanical Engineering
Medieval Studies
Microbial Sciences
Mind, Brain, Behavior
Molecular and Cellular Biology
Music
Near Eastern Languages and Civilizations
Neuroscience
Philosophy
Physics
Psychology
Romance Languages and Literatures
Russia, Eastern Europe, and Central Asia
Theatre, Dance, and Media
Slavic Languages and Literatures
Social Studies
Sociology
South Asian Studies
Statistics
Studies of Women, Gender, and Sexuality
Translation Studies`
.split('\n'); //

export default concentrations;